export default __webpack_public_path__ + "static/media/publicity-team-member-1.49800a3c.jpg";